/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateDevice = /* GraphQL */ `
  subscription OnCreateDevice($filter: ModelSubscriptionDeviceFilterInput) {
    onCreateDevice(filter: $filter) {
      recordType
      recordID
      appState0
      appState1
      appState2
      appState3
      appState4
      appState5
      appState6
      appState7
      appState8
      appState9
      appState10
      appState11
      appState12
      appState13
      appState14
      caseTemp
      connectionStatus
      controllerStatus
      createdAt
      customMac
      customUniqueDeviceId
      datetime
      faults
      heaterState
      heater2State
      macAddress
      modelType
      notes
      ORP
      ORP_RT
      PH
      PH_RT
      PoolTemp
      pumpState
      RoofTemp
      updatedAt
      userName
      userID
      WaterTemp
      group
      acidDosing
      chlorineDosing
      serial_number
      versionNumber
      archived
      productionTest
      date
      ioVersion
      exp1Version
      exp2Version
      chemVersion
      errorCode
      OtherTemp
      poolSP
      spaSP
      pool2SP
      spa2SP
      solarSP
      ORPSP
      PHSP
      version
      spaMode
      amps
      volts
      volts_2
      __typename
    }
  }
`;
export const onUpdateDevice = /* GraphQL */ `
  subscription OnUpdateDevice($filter: ModelSubscriptionDeviceFilterInput) {
    onUpdateDevice(filter: $filter) {
      recordType
      recordID
      appState0
      appState1
      appState2
      appState3
      appState4
      appState5
      appState6
      appState7
      appState8
      appState9
      appState10
      appState11
      appState12
      appState13
      appState14
      caseTemp
      connectionStatus
      controllerStatus
      createdAt
      customMac
      customUniqueDeviceId
      datetime
      faults
      heaterState
      heater2State
      macAddress
      modelType
      notes
      ORP
      ORP_RT
      PH
      PH_RT
      PoolTemp
      pumpState
      RoofTemp
      updatedAt
      userName
      userID
      WaterTemp
      group
      acidDosing
      chlorineDosing
      serial_number
      versionNumber
      archived
      productionTest
      date
      ioVersion
      exp1Version
      exp2Version
      chemVersion
      errorCode
      OtherTemp
      poolSP
      spaSP
      pool2SP
      spa2SP
      solarSP
      ORPSP
      PHSP
      version
      spaMode
      amps
      volts
      volts_2
      __typename
    }
  }
`;
export const onDeleteDevice = /* GraphQL */ `
  subscription OnDeleteDevice($filter: ModelSubscriptionDeviceFilterInput) {
    onDeleteDevice(filter: $filter) {
      recordType
      recordID
      appState0
      appState1
      appState2
      appState3
      appState4
      appState5
      appState6
      appState7
      appState8
      appState9
      appState10
      appState11
      appState12
      appState13
      appState14
      caseTemp
      connectionStatus
      controllerStatus
      createdAt
      customMac
      customUniqueDeviceId
      datetime
      faults
      heaterState
      heater2State
      macAddress
      modelType
      notes
      ORP
      ORP_RT
      PH
      PH_RT
      PoolTemp
      pumpState
      RoofTemp
      updatedAt
      userName
      userID
      WaterTemp
      group
      acidDosing
      chlorineDosing
      serial_number
      versionNumber
      archived
      productionTest
      date
      ioVersion
      exp1Version
      exp2Version
      chemVersion
      errorCode
      OtherTemp
      poolSP
      spaSP
      pool2SP
      spa2SP
      solarSP
      ORPSP
      PHSP
      version
      spaMode
      amps
      volts
      volts_2
      __typename
    }
  }
`;
export const onCreateInformation = /* GraphQL */ `
  subscription OnCreateInformation(
    $filter: ModelSubscriptionInformationFilterInput
  ) {
    onCreateInformation(filter: $filter) {
      recordType
      recordID
      connectionStatus
      controllerStatus
      createdAt
      customMac
      customUniqueDeviceId
      datetime
      faults
      macAddress
      modelType
      notes
      updatedAt
      userName
      userID
      group
      serial_number
      versionNumber
      archived
      productionTest
      date
      ioVersion
      exp1Version
      exp2Version
      chemVersion
      errorCode
      version
      __typename
    }
  }
`;
export const onUpdateInformation = /* GraphQL */ `
  subscription OnUpdateInformation(
    $filter: ModelSubscriptionInformationFilterInput
  ) {
    onUpdateInformation(filter: $filter) {
      recordType
      recordID
      connectionStatus
      controllerStatus
      createdAt
      customMac
      customUniqueDeviceId
      datetime
      faults
      macAddress
      modelType
      notes
      updatedAt
      userName
      userID
      group
      serial_number
      versionNumber
      archived
      productionTest
      date
      ioVersion
      exp1Version
      exp2Version
      chemVersion
      errorCode
      version
      __typename
    }
  }
`;
export const onDeleteInformation = /* GraphQL */ `
  subscription OnDeleteInformation(
    $filter: ModelSubscriptionInformationFilterInput
  ) {
    onDeleteInformation(filter: $filter) {
      recordType
      recordID
      connectionStatus
      controllerStatus
      createdAt
      customMac
      customUniqueDeviceId
      datetime
      faults
      macAddress
      modelType
      notes
      updatedAt
      userName
      userID
      group
      serial_number
      versionNumber
      archived
      productionTest
      date
      ioVersion
      exp1Version
      exp2Version
      chemVersion
      errorCode
      version
      __typename
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
    onCreateUser(filter: $filter) {
      recordType
      recordID
      last_accessed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
    onUpdateUser(filter: $filter) {
      recordType
      recordID
      last_accessed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
    onDeleteUser(filter: $filter) {
      recordType
      recordID
      last_accessed
      createdAt
      updatedAt
      __typename
    }
  }
`;
